<div
  class="layout-wrapper layout-content-navbar"
  style="background-color: #ffffff"
>
  <div class="layout-container d-flex">
    <app-side-nav></app-side-nav>

    <div class="container-fluid flex-grow-1 mt-2 px-3">
      <div
        class="d-flex justify-content-between align-items-center py-3 mb-4"
        style="margin-top: -12px"
      >
        <h4 class="users-heading">
          <span class="text-muted fw-light">Access Management /</span> Access List
        </h4>
        <button
          class="btn custom-button"
          (click)="openAddAccessModal()"
          style="margin-right: 0px !important; margin-bottom: -20px"
        >
          + Add Access
        </button>
      </div>
      <div class="filter-row d-flex flex-wrap gap-2 mb-3">
        <!-- Search by Email -->
        <div class="flex-grow-1" style="min-width: 200px">
          <input
            type="text"
            placeholder="Search by email"
            [(ngModel)]="searchText"
            class="form-control filter-input"
            (keydown.enter)="searchAccess()"
          />
        </div>

        <div class="flex-grow-1" style="min-width: 150px">
          <select
            [(ngModel)]="subscriptionFilter"
            class="form-select cursor-pointer"
          >
            <option value="" disabled selected hidden>
              Filter Subscription Type
            </option>
            <option value="Standard">Standard</option>
            <option value="Premium">Premium</option>
            <option value="Enterprise">Enterprise</option>
          </select>
        </div>

        <div class="flex-grow-1" style="min-width: 150px">
          <select [(ngModel)]="statusFilter" class="form-select cursor-pointer">
            <option value="" disabled selected hidden>Filter By Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <!-- Search Button -->

        <div class="d-flex gap-2">
          <button class="btn custom-button" (click)="searchAccess()">
            Search
          </button>
          <button class="btn custom-button" (click)="clear()">Clear</button>
        </div>
      </div>

      <!-- Spinner -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="height: 150px"
      >
        <div class="spinner-border text-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Access Table -->
      <div class="card" *ngIf="!loading" style="margin-top: 10px">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Email</th>
                <th>Subscription Type</th>
                <th>Duration</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let access of paginatedData; let i = index">
                <td>{{ access.email }}</td>
                <td>{{ access.subscription_type }}</td>
                <td>{{ access.duration || access.duration_months }} {{ ((access.duration_months || access.duration) == 1) ? 'Month' : 'Months' }}</td>
                <td>
                  <span class="badge bg-label-primary me-1">
                    {{ access.status }}
                  </span>
                </td>
                <td>
                  <div class="dropdown" data-bs-display="static">
                    <button
                      type="button"
                      class="btn p-0 dropdown-toggle hide-arrow"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul
                      class="dropdown-menu dropdown-menu-end custom-dropdown-menu"
                    >
                      <!-- <li>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0);"
                          (click)="openEditAccessModal(access)"
                        >
                          <i class="bx bx-edit-alt me-1"></i> Edit
                        </a>
                      </li> -->
                      <li>
                        <a
                          class="dropdown-item"
                          href="javascript:void(0);"
                          (click)="toggleAccessStatus(access)"
                        >
                          <i
                            class="bx {{
                              access.status === 'Active'
                                ? 'bx-user-x'
                                : 'bx-user-check'
                            }} me-1"
                          ></i>
                          {{ access.status === 'Active' ? 'Inactive' : 'Active' }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-center mt-4">
        <!-- Pagination Controls -->
        <nav aria-label="Page navigation">
          <ul class="pagination mb-0">
            <!-- Previous Button -->
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="prevPage()"
                >Previous</a
              >
            </li>

            <!-- Page Numbers -->
            <li
              *ngFor="let page of pageRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="goToPage(page)"
                >{{ page }}</a
              >
            </li>

            <!-- Next Button -->
            <li class="page-item" [class.disabled]="currentPage === pages">
              <a
                class="page-link"
                href="javascript:void(0);"
                (click)="nextPage()"
                >Next</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Add Access Modal -->
<div class="modal fade" id="addAccessModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Access</h5>
      </div>
      <div class="modal-body">
        <app-add-access
          (accessAddedEvent)="onAccessAdded()"
          (closeFormEvent)="onAccessAdded()"
        >
        </app-add-access>
      </div>
    </div>
  </div>
</div>

<!-- Edit Access Modal -->
<!-- TODO: Create edit-access component similar to edit-user -->
<!-- <div class="modal fade" id="editAccessModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Access</h5>
      </div>
      <div class="modal-body">
        <app-edit-access
          [accessId]="selectedAccessId"
          (accessUpdatedEvent)="onAccessUpdated()"
          (closeFormEvent)="onAccessUpdated()"
        >
        </app-edit-access>
      </div>
    </div>
  </div>
</div> -->

